export default Object.freeze({
  Nuevo: 1,
  Sometido: 2,
  Cancelado: 3,
});
